import type React from 'react'
import { useLayoutEffect, useState } from 'react'

export function useTruncationDetection({
  ref,
}: {
  ref: React.RefObject<HTMLElement>
}) {
  const [isTruncated, setIsTruncated] = useState(false)

  // Run the resize observer to only show the tooltip when the text is truncated
  useLayoutEffect(() => {
    let timeout: NodeJS.Timeout | null = null

    const runResizeObserver = () => {
      if (timeout) clearTimeout(timeout)

      timeout = setTimeout(() => {
        if (ref.current) {
          setIsTruncated(ref.current.scrollWidth > ref.current.clientWidth)
        }
      }, 100)
    }

    let attempts = 0
    const installObserver = () => {
      if (ref.current) {
        observer.observe(ref.current as HTMLElement)
        runResizeObserver()
      } else {
        attempts++
        if (attempts > 10) {
          console.warn('Unable to find ref for resize observer - giving up')
          return
        }
        setTimeout(() => {
          installObserver()
        }, 100)
      }
    }
    const observer = new ResizeObserver(runResizeObserver)

    installObserver()
    runResizeObserver()

    return () => {
      observer.disconnect()
      if (timeout) clearTimeout(timeout)
    }
  }, [ref])

  return {
    isTruncated,
  }
}
